// extracted by mini-css-extract-plugin
export var header = "_ez-0";